import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'store-transfer',
    component: RouterView,
    children: [
      {
        path: '',
        component: () => import('@/app/modules/store-transfer/views/store-transfer-index.vue'),
        meta: {
          layoutFeatures: {
            actionPanel: true,
          },
        },
        children: [
          {
            path: '',
            component: () =>
              import('@/app/modules/store-transfer/views/store-transfer-homepage.vue'),
            meta: {
              layoutFeatures: {
                pageControlsTarget: 'end',
              },
            },
          },
          {
            path: 'compliance-date',
            component: () =>
              import('@/app/modules/store-transfer/views/store-transfer-compliance-date.vue'),
            meta: {
              pageTitle: 'Store Transfer • IST Compliance by Date',
            },
          },
          {
            path: 'compliance-store',
            component: () =>
              import('@/app/modules/store-transfer/views/store-transfer-compliance-store.vue'),
            meta: {
              pageTitle: 'Store Transfer • IST Compliance by Store',
            },
          },
          {
            path: 'recommendations',
            component: () =>
              import('@/app/modules/store-transfer/views/store-transfer-recommendations.vue'),
            children: [
              {
                path: 'trips',
                component: () =>
                  import('@/app/modules/store-transfer/views/store-transfer-recommendations-trips.vue'),
              },
              {
                path: 'products',
                component: () =>
                  import('@/app/modules/store-transfer/views/store-transfer-recommendations-products.vue'),
              },
            ],
          },
          {
            path: 'analysis',
            component: () =>
              import('@/app/modules/store-transfer/views/store-transfer-analysis.vue'),
          },
          {
            path: 'cluster-sku-trips',
            component: () =>
              import('@/app/modules/store-transfer/views/store-transfer-cluster-sku-trips.vue'),
          },
        ],
      },
      {
        path: 'objective/:objectiveId/exploration',
        component: () =>
          import('@/app/modules/store-transfer/views/store-transfer-objective-exploration.vue'),
        meta: {
          layoutFeatures: {
            sidebar: false,
          },
        },
      },
    ],
  },
];
export default routes;
